import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var GET_FILTER_INPUTS = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query GetFilterInputsForModal {\n        __type(name: \"ProductAttributeFilterInput\") {\n            inputFields {\n                name\n                type {\n                    name\n                }\n            }\n        }\n    }\n"])));
export default {
  getFilterInputsQuery: GET_FILTER_INPUTS
};